import { ENABLED_AQUA } from '@openx/constants/feature-flag-keys';
import { ACL_TYPE } from '@openx/types/aclType';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isUserAllowedByAcl } from '@openx/utils/permission/validators';
import type { JSX } from 'react';
import { Navigate, Outlet } from 'react-router';

export const AquaRouteGuard = (): JSX.Element => {
  const { useIsAllowed, isGrowthbookFeatureOn } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  const isAquaEnabled: boolean =
    isGrowthbookFeatureOn(ENABLED_AQUA) && isAllowed(isUserAllowedByAcl(ACL_TYPE.AQUA_ENABLED));

  if (!isAquaEnabled) {
    return <Navigate to="/deals" replace />;
  }

  return <Outlet />;
};
